export default __webpack_public_path__ + "static/media/nzl_icon.4324f8ca.png";